import { FunctionComponent } from 'react';
import { TagProps } from './TagProps';

export const Tag: FunctionComponent<TagProps> = ({ icon, data }) => {
  return (
    <div className="px-3 py-0.5 h-stack items-center justify-center space-x-2 bg-tint bg-opacity-10 rounded-full">
      <img className="w-4 h-4" src={icon} />
      <h5 className="text-tint">{data}</h5>
    </div>
  );
};
